
import {FC} from 'react'

import { PickupFeesReport } from '../../modules/orders/PickupFeesReport';


const PickupFeesPage: FC = () => {
    return (
        <>
            <PickupFeesReport/>
        </>
    )
}

export default PickupFeesPage
